import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './SubscriptionExpired.scss';

export default function SubscriptionExpired() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className='subscriptionExpired'>
            <div className='subscriptionExpired_wrapper'>
                <h1>Subskrypcja wygasła</h1>
                <p>Twoja subskrypcja wygasła. W celu jej przedłużenia skontaktuj się z nami.</p>
                <p className='subscriptionExpired_contact'>Kontakt: <a href='mailto:nekrodruk@gmail.com'>nekrodruk@gmail.com</a></p>
                <NavLink to='/' className='subscriptionExpired_home'>Powrót na stronę główną</NavLink>
            </div>
        </section>
    );
}
